import React from "react";

const Loader = ({ label = "Loading" }) => {
  return <div className="loader">{label}...</div>;
};

export default Loader;
